import {ReplaySubject} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DcService {
  public detectChangesConnect$: ReplaySubject<void> = new ReplaySubject();
  public detectChanges$: ReplaySubject<string> = new ReplaySubject();
}
